import React, { useEffect, useState } from 'react'
import {
  View,
  Text,
  ScrollView,
  Touchable,
  TouchableOpacity,
  StyleSheet,
  Dimensions,
  Platform,
  ActivityIndicator,
  Linking
} from 'react-native'
import { colorPalette, globalStyles } from '../../../static/styles/global'
import { Ionicons, AntDesign, FontAwesome, Feather } from '@expo/vector-icons'

import Card from '../../../components/shared/card/Card'
import { usepaycheckStore } from '../../../stores/paycheck'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import moment from 'moment'
import { useLabourStore } from '../../../stores/labour'
import { useTranslation } from 'react-i18next'
import { useHomeStore } from '../../../stores/home'
import HomeDetailsHeader from '../../../components/home/HomeDetailsHeader'

type reuseparams = {
  SSN: string
  year: string
  ein: string
  w2id: string
  client: string
  isCorrectionW2: boolean
  seqNo: string
}

const Vieww2 = ({ navigation, route }: any) => {

  const { params } = route
  const { mostRecentUserOnBoardings } = params
  const store = usepaycheckStore()
  const intializestore = useInitializeStore()
  const personalstore = usePersonalStore()
  const labourstore = useLabourStore()
  const homestore = useHomeStore()


  const { mostRecentUserOnBoardings: userId, refresh } = route.params
  const { t } = useTranslation()

  useEffect(() => {
    store.fetchW2Forms(personalstore?.personalData?.entityId, labourstore?.labourData?.employeeNumber, intializestore?.initializeData?.userkey, mostRecentUserOnBoardings, personalstore?.personalData?.corpEntityId, homestore?.homeData?.storeNumber)
  }, [])



  const handleView = async (w2id: any, userkey: any, userId: any, year: any, isCorrectionW2: any, seqNo: any) => {
    try {
      const response = await store.fetchw2file(w2id, userkey, userId, year, isCorrectionW2, seqNo)
      const blob = new Blob([response], { type: 'application/pdf' })
      const url = URL.createObjectURL(blob)
      Linking.openURL(url)
    } catch (error) {
      console.error('Error:', error)
    }
  }

  const Reuse = ({
    SSN,
    year,
    ein,
    w2id,
    client,
    isCorrectionW2,
    seqNo

  }: reuseparams) => {

    return (
      <View style={styles.CardProfile}>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          <View style={{ flex: 2 }}>
            <Text style={{ color: '#0B495C', fontWeight: '600' }}>EIN</Text>
            <Text >{ein}</Text>
          </View>
          <View style={{ flex: 1 }}>
            <Text style={{ color: '#0B495C', fontWeight: '600' }}>
              {t('Year / Sequence')}
            </Text>
            <Text style={{ textAlign: 'left' }}>{year} / {seqNo}</Text>
          </View>
          <View style={{ flex: 1, alignItems: 'center' }} >
            <Text style={{ color: '#0B495C', fontWeight: '600' }}>
              {t('W-2')}
            </Text>
            <Text>
              <TouchableOpacity
                style={{ marginTop: 7 }}
                onPress={() => {
                  handleView(
                    w2id,
                    intializestore.initializeData.userkey,
                    userId,
                    year,
                    false,
                    seqNo
                  )
                }}
              >
                <FontAwesome
                  name="file-pdf-o"
                  size={25}
                  color={colorPalette.red}
                />
              </TouchableOpacity>
            </Text>
          </View>
          <View style={{ flex: 1, alignItems: 'center', opacity: isCorrectionW2 ? 1 : 0 }}>
            {isCorrectionW2 && (
              <View >
                <Text style={{ color: '#0B495C', fontWeight: '600' }}>
                  {t('W-2c')}
                </Text>
                <Text>
                  <TouchableOpacity
                    style={{ marginTop: 7 }}
                    onPress={() => {
                      handleView(
                        w2id,
                        intializestore.initializeData.userkey,
                        userId,
                        year,
                        isCorrectionW2,
                        seqNo
                      )
                    }}
                  >
                    <FontAwesome
                      name="file-pdf-o"
                      size={25}
                      color={colorPalette.red}
                    />
                  </TouchableOpacity>
                </Text>
              </View>
            )}
          </View>
        </View>

      </View>
    )
  }

  return (
    <ScrollView>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navScreen='PayrollDocuments'
            navLabel={t('Payroll Documents')}
            title={t('View W-2 Forms')}
          />
        </View>
      </View>
      <View style={[globalStyles.containerOverlap]}>
        <Card>
          <ScrollView>
            {store.loading ? <ActivityIndicator size="large" /> :
              store?.w2formsData && store?.w2formsData?.data?.length > 0 ? (
                <>
                  {store.w2formsData.data.map((item) => {
                    return (
                      <>
                        <Reuse SSN={item.eoyssan} year={item.year} ein={item.ein} w2id={item.w2id} client={item.dclnclientName} isCorrectionW2={item.isCorrectionW2} seqNo={item.eoyseqno} />
                      </>
                    )
                  })}
                </>
              ) : (
                <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                  <Text style={{ fontWeight: 'bold' }}>
                    {t('No W-2 Forms are available')}
                  </Text>
                </View>
              )}
          </ScrollView>
        </Card>
      </View>
    </ScrollView>
  )
}
export default Vieww2

const styles = StyleSheet.create({
  CardProfile: {
    backgroundColor: colorPalette.light,
    padding: 16,
    borderRadius: 8,
    margin: 10,

  }
})
